import { registerPlugin } from '@capacitor/core';

export interface MicrosoftAuthPlugin {
  login(): Promise<{
    accessToken: string;
    id?: string;
    username?: string;
    name?:string;
    foto?: string;
  }>;
}

export const MicrosoftAuth =
  registerPlugin<MicrosoftAuthPlugin>('MicrosoftAuth');